

const BOTMAKER_URL = 'https://botmaker.xavisoft.co.zw';

export {
   BOTMAKER_URL
}